"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4843],{

/***/ 37989:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Lw": function() { return /* binding */ ButtonDiv; },
/* harmony export */   "yU": function() { return /* binding */ TypographyButton; },
/* harmony export */   "zx": function() { return /* binding */ Button; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47842);
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13264);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29630);



var ButtonDiv = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div")({
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
    position: "fixed",
    bottom: "0",
    width: "100%",
    height: "80px",
    backgroundColor: "white",
    borderTop: "1px solid #EAEAEA",
    zIndex: 2,
    "@media (min-width: 900px)": {
        position: "sticky"
    }
});
var Button = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("button", {
    shouldForwardProp: function(prop) {
        return prop !== "disabled";
    }
})(function(param) {
    var disabled = param.disabled, theme = param.theme;
    var _obj;
    return _obj = {
        backgroundColor: disabled ? "#EAEAEA" : "#0A7ABE",
        borderRadius: "100px",
        padding: "8px 60px",
        cursor: disabled ? "default" : "pointer",
        border: "none",
        transition: "all 0.3s ease-in-out",
        color: "white",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: 8
    }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, theme.breakpoints.down(330), {
        padding: "8px 40px"
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, theme.breakpoints.down(275), {
        padding: "8px 20px"
    }), _obj;
});
var TypographyButton = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        fontFamily: "Poppins",
        fontWeight: 400,
        fontSize: "16px",
        lineHeight: "24px",
        letterSpacing: "0.15px"
    }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, theme.breakpoints.down(400), {
        fontSize: "14px"
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, theme.breakpoints.down(275), {
        fontSize: "12px"
    }), _obj;
});



/***/ }),

/***/ 19906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ps": function() { return /* binding */ StyledSkeleton; },
/* harmony export */   "q4": function() { return /* binding */ CardSkeleton; }
/* harmony export */ });
/* unused harmony export MarginSkeleton */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47842);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13264);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91655);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-bottom: 5px;\n  padding: 0px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 15px 0px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var CardSkeleton = (0,_mui_system__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("a")(function(param) {
    var theme = param.theme, listLength = param.listLength;
    var _obj;
    return _obj = {
        width: "200px",
        minWidth: "151px",
        minHeight: "199px",
        border: "1px solid #EAEAEA",
        borderWidth: "0px 1px 1px 0px",
        textDecoration: "none",
        scrollSnapAlign: "start",
        position: "relative",
        cursor: "pointer",
        display: "flex",
        flexDirection: "column",
        padding: "17px 15px"
    }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, theme.breakpoints.up(320), {
        width: "".concat(Math.max(100 / listLength, 50), "%"),
        minWidth: 150
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, theme.breakpoints.up(470), {
        width: "".concat(Math.max(100 / listLength, 33.3), "%")
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, theme.breakpoints.up(620), {
        width: "".concat(Math.max(100 / listLength, 25), "%")
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, theme.breakpoints.up(770), {
        width: listLength > 3 ? "33.3%" : 200,
        minWidth: 200
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, theme.breakpoints.up(820), {
        width: listLength > 4 ? "25%" : 200
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, theme.breakpoints.up(1020), {
        width: listLength > 5 ? "20%" : 200
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, theme.breakpoints.up(1220), {
        width: 200
    }), _obj;
});
var StyledSkeleton = (0,_mui_system__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_templateObject());
var MarginSkeleton = (0,_mui_system__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_templateObject1());



/***/ }),

/***/ 95790:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "pl": function() { return /* reexport */ OtherPaymentMethods; },
  "KR": function() { return /* reexport */ isPaymentMethodDataOneClick; }
});

// UNUSED EXPORTS: AssistantVendorPaymentMethods, LocalVendorPaymentMethods

;// CONCATENATED MODULE: ./src/interfaces/paymentMethod.interface.ts
/*
 * File: paymentMethod.interface.ts
 * Project: meki
 * File Created: Monday, 5th October 2020 4:53:04 pm
 * Author: Vicente Melin (vicente@inventures.cl)
 * -----
 * Last Modified: Thursday, 20th October 2022 12:07:53 am
 * Modified By: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Copyright 2019 - 2020 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ var OtherPaymentMethods;
(function(OtherPaymentMethods) {
    OtherPaymentMethods["FINTOC"] = "Fintoc";
    OtherPaymentMethods["BANCO_ESTADO"] = "BancoEstado";
})(OtherPaymentMethods || (OtherPaymentMethods = {}));
function isPaymentMethodDataOneClick(data) {
    return typeof data === "object" && data !== null && "tbkUser" in data;
}

;// CONCATENATED MODULE: ./src/interfaces/order.interface.ts
/*
 * File: order.interface.ts
 * Project: meki
 * File Created: Wednesday, 21st October 2020 8:51:58 am
 * Author: Vicente Melin (vicente@inventures.cl)
 * -----
 * Last Modified: Monday, 19th June 2023 9:56:11 am
 * Modified By: Blanca Munizaga (blanca@inventures.cl)
 * -----
 * Copyright 2019 - 2020 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ var LocalVendorPaymentMethods;
(function(LocalVendorPaymentMethods) {
    LocalVendorPaymentMethods["TRANSFER"] = "TRANSFER";
    LocalVendorPaymentMethods["CARD_CASH"] = "CARD_CASH";
    LocalVendorPaymentMethods["CARD"] = "CARD";
    LocalVendorPaymentMethods["CASH"] = "CASH";
})(LocalVendorPaymentMethods || (LocalVendorPaymentMethods = {}));
var AssistantVendorPaymentMethods;
(function(AssistantVendorPaymentMethods) {
    AssistantVendorPaymentMethods["TRANSFER"] = "TRANSFER";
    AssistantVendorPaymentMethods["CARD"] = "CARD";
})(AssistantVendorPaymentMethods || (AssistantVendorPaymentMethods = {}));

;// CONCATENATED MODULE: ./src/interfaces/index.ts
/*
 * File: index.ts
 * Project: meki
 * File Created: Monday, 21st September 2020 5:35:28 pm
 * Author: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Last Modified: Friday, 3rd February 2023 9:38:17 am
 * Modified By: Blanca Munizaga (blanca@inventures.cl)
 * -----
 * Copyright 2019 - 2020 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ 























/***/ }),

/***/ 50952:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ assignPaymentMethod; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68921);
/*
 * File: assignPaymentMethod.tsx
 * Project: meki
 * File Created: Friday, 16th April 2021 7:56:49 am
 * Author: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Last Modified: Thursday, 11th November 2021 3:50:32 pm
 * Modified By: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Copyright 2019 - 2021 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation checkoutAssignPaymentMethod($params: AssignPaymentMethodParams!) {\n    assignPaymentMethod(params: $params) {\n      id\n      uuid\n      paymentMethod {\n        id\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var assignPaymentMethod = function() {
    return (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());
};


/***/ }),

/***/ 45482:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ OrderDeliveryOptions; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68921);
/*
 * File: detail.ts
 * Project: meki
 * File Created: Wednesday, 10th November 2021 4:58:00 pm
 * Author: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Last Modified: Friday, 1st December 2023 11:26:50 am
 * Modified By: Blanca Munizaga (blanca@inventures.cl)
 * -----
 * Copyright 2019 - 2021 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query OrderDeliveryOptions($params: OrderDeliveryOptionsParams!) {\n    orderDeliveryOptions(params: $params) {\n      dates\n      currentOrderId\n      deliveryCost\n      orders {\n        deliveryDate\n        deliveryType\n        deliveryCost\n        deliveryCoupon\n        totalCost\n        orderDetails {\n          quantity\n          product {\n            id\n            name\n            imagesUrl\n            activePrinciple\n            concentration\n            unit\n            prescriptionType\n            quantity\n            discount {\n              price\n              type\n              stockRestriction\n              dateRestriction\n              listPrice\n            }\n            format\n            price\n            container\n            containerQuantity\n            concentration\n            laboratory\n            availability {\n              stock\n              statusWithoutStock\n              status\n            }\n          }\n          price\n          type\n          listPrice\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var OrderDeliveryOptions = function() {
    return (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());
};


/***/ }),

/***/ 66003:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ getCheckoutPaymentMethod; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68921);
/*
 * File: summary.ts
 * Project: meki
 * File Created: Thursday, 11th November 2021 10:55:35 am
 * Author: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Last Modified: Friday, 1st December 2023 11:26:34 am
 * Modified By: Blanca Munizaga (blanca@inventures.cl)
 * -----
 * Copyright 2019 - 2021 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query getCheckoutPaymentMethod($params: CurrentOrderParams) {\n    currentOrder(params: $params) {\n      id\n      uuid\n      orderGroupId\n      deliveryCost\n      metadata {\n        useMekiCredits\n        installments\n        payments {\n          amount\n          type\n        }\n        userInfo {\n          email\n          name\n          rut\n        }\n        sendEmail\n        insuranceInfo {\n          insuranceId\n          totalReimbursement\n          totalDeductible\n          reimbursedProducts {\n            sku\n            observation\n            unitReimbursement\n            unitCopay\n            unitDeductible\n            coverage\n          }\n        }\n        localVendor {\n          paymentMethod\n          mixPayments\n        }\n        assistantVendor {\n          paymentMethod\n        }\n        chargeDeliveryCost\n      }\n      paymentMethod {\n        id\n        uuid\n        type\n        data\n      }\n      address {\n        id\n        name\n        street\n        streetNumber\n        commune\n      }\n    }\n    paymentMethods {\n      id\n      uuid\n      type\n      data\n    }\n    currentUserInfo {\n      credits\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var getCheckoutPaymentMethod = function() {
    return (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());
};


/***/ }),

/***/ 43013:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ setCheckoutOrderData; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68921);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation SetCheckoutOrderData($params: SetCheckoutOrderDataParams!) {\n    setCheckoutOrderData(params: $params) {\n      metadata {\n        useMekiCredits\n        chargeDeliveryCost\n        localVendor {\n          paymentMethod\n          mixPayments\n        }\n        assistantVendor {\n          paymentMethod\n        }\n        userInfo {\n          rut\n          name\n          email\n        }\n        sendEmail\n        insuranceInfo {\n          claimId\n          insuranceId\n          reimbursedProducts {\n            sku\n            observation\n            unitReimbursement\n            unitCopay\n            unitDeductible\n            coverage\n          }\n          rut\n          totalReimbursement\n          totalDeductible\n          totalCopay\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var setCheckoutOrderData = function() {
    return (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());
};


/***/ }),

/***/ 66860:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ finishOneClickInscription; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68921);
/*
 * File: finishOneClickInscription.ts
 * Project: meki
 * File Created: Tuesday, 27th October 2020 12:53:23 pm
 * Author: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Last Modified: Friday, 22nd July 2022 3:30:59 pm
 * Modified By: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Copyright 2019 - 2020 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation ",
        " ($params: FinishOneClickInscriptionParams!) {\n    finishOneClickInscription(params: $params) {\n      id\n      uuid\n      type\n      data\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var finishOneClickInscription = function(name) {
    return (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject(), name);
};


/***/ }),

/***/ 50018:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ getOneClickRedirect; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68921);
/*
 * File: getOneClickRedirect.ts
 * Project: meki
 * File Created: Tuesday, 27th October 2020 12:53:23 pm
 * Author: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Last Modified: Monday, 21st December 2020 3:20:19 pm
 * Modified By: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Copyright 2019 - 2020 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query ",
        " ($params: GetRedirectUrlOneClickParams!) {\n    getRedirectUrlOneClick(params: $params) {\n      url\n      token\n      method\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var getOneClickRedirect = function(name) {
    return (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject(), name);
};


/***/ }),

/***/ 90534:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ getInsuranceQuote; }
/* harmony export */ });
/* unused harmony export QuoteStatus */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68921);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query getInsuranceQuote($params: GetInsuranceQuote!) {\n    getInsuranceQuote(params: $params) {\n      claimId\n      insuranceId\n      totalDeductible\n      totalReimbursement\n      totalCopay\n      metadata\n      reimbursedProducts {\n        sku\n        observation\n        unitReimbursement\n        unitDeductible\n        unitCopay\n        coverage\n        quantity\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var getInsuranceQuote = function() {
    return (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());
};
var TributaryDocument;
(function(TributaryDocument) {
    TributaryDocument["BILL"] = "BILL";
    TributaryDocument["DISPATCH_NOTE"] = "DISPATCH_NOTE";
})(TributaryDocument || (TributaryDocument = {}));
var QuoteStatus;
(function(QuoteStatus) {
    QuoteStatus["PENDING"] = "PENDING";
    QuoteStatus["CONFIRMED"] = "CONFIRMED";
    QuoteStatus["CANCELLED"] = "CANCELLED";
    QuoteStatus["CANCELLED_FAILED"] = "CANCELLED_FAILED";
    QuoteStatus["DISCARDED"] = "DISCARDED";
})(QuoteStatus || (QuoteStatus = {}));


/***/ }),

/***/ 6577:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GL": function() { return /* binding */ InfoDiv; },
/* harmony export */   "JE": function() { return /* binding */ InfoIconButton; },
/* harmony export */   "Jg": function() { return /* binding */ AddressInput; },
/* harmony export */   "L": function() { return /* binding */ AddressTypographyTitle; },
/* harmony export */   "LR": function() { return /* binding */ SkeletonInput; },
/* harmony export */   "O3": function() { return /* binding */ DivisionLine; },
/* harmony export */   "Ub": function() { return /* binding */ AddressTypographyDiv; },
/* harmony export */   "_m": function() { return /* binding */ AddressDiv; },
/* harmony export */   "_p": function() { return /* binding */ AddAddressDiv; },
/* harmony export */   "bD": function() { return /* binding */ AddAddressIconButton; },
/* harmony export */   "dP": function() { return /* binding */ TitleTypography; },
/* harmony export */   "kQ": function() { return /* binding */ SkeletonTitle; },
/* harmony export */   "mh": function() { return /* binding */ InfoTypography; },
/* harmony export */   "n2": function() { return /* binding */ AddressTypographySubTitle; },
/* harmony export */   "of": function() { return /* binding */ RootDiv; },
/* harmony export */   "v9": function() { return /* binding */ SkeletonSubTitle; },
/* harmony export */   "yy": function() { return /* binding */ AddAddressTypography; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70865);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29630);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80562);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91655);
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13264);




var RootDiv = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div", {
    shouldForwardProp: function(prop) {
        return prop !== "missinInfo";
    }
})(function(param) {
    var missingInfo = param.missingInfo;
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
        display: "flex",
        flexDirection: "column",
        backgroundColor: "white",
        border: "1px solid #EAEAEA",
        borderRadius: "10px"
    }, missingInfo && {
        border: "1px solid #FF0000"
    });
});
var TitleTypography = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    fontFamily: "Poppins",
    fontWeight: 600,
    fontSize: "16px",
    lineHeight: "24px",
    letterSpacing: "0.15px",
    color: "#414046",
    marginBottom: "12px",
    textAlign: "left",
    marginLeft: "12px",
    marginTop: "12px"
});
var DivisionLine = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div")({
    height: "1px",
    backgroundColor: "#EAEAEA"
});
var AddressDiv = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div")({
    display: "flex",
    alignItems: "center",
    padding: "14px 25px",
    borderBottom: "1px solid #EAEAEA",
    position: "relative",
    cursor: "pointer",
    ":nth-last-child": {
        borderBottom: "none !important"
    }
});
var AddressInput = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("input")({
    cursor: "pointer",
    marginRight: "25px",
    WebkitAppearance: "none",
    width: "20px",
    height: "20px",
    borderRadius: "50%",
    outline: "none",
    border: "2px solid #0277BD",
    minWidth: "20px",
    ":before": {
        content: '""',
        display: "block",
        width: "60%",
        height: "60%",
        margin: "20% auto",
        borderRadius: "50%"
    },
    ":checked:before": {
        backgroundColor: "#0277BD"
    }
});
var AddressTypographyDiv = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div")({
    display: "flex",
    flexDirection: "column"
});
var AddressTypographyTitle = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    fontFamily: "Poppins",
    fontWeight: 500,
    fontSize: "12px",
    lineHeight: "18px",
    letterSpacing: "0.16px",
    marginBottom: "6px",
    color: "#414046"
});
var AddressTypographySubTitle = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    fontFamily: "Poppins",
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "18px",
    letterSpacing: "0.16px",
    margin: 0,
    color: "#919191"
});
var AddAddressDiv = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div")({
    display: "flex",
    alignItems: "center",
    padding: "14px 22px",
    cursor: "pointer"
});
var AddAddressIconButton = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    padding: "0",
    marginRight: "17px",
    color: "#0A7ABE"
});
var AddAddressTypography = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    fontFamily: "Poppins",
    fontWeight: 500,
    fontSize: "13px",
    lineHeight: "19.5px",
    letterSpacing: "0.16px",
    color: "#0A7ABE",
    cursor: "pointer"
});
var InfoDiv = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div")({
    display: "flex",
    alignItems: "center",
    padding: "10px 10px 10px 22px",
    backgroundColor: "#E6F3FA",
    marginTop: "12px"
});
var InfoIconButton = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    padding: "0",
    marginRight: "17px",
    color: "#414046"
});
var InfoTypography = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    fontFamily: "Poppins",
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "15.6px",
    letterSpacing: "0.15px",
    color: "#414046"
});
var SkeletonInput = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
    marginRight: "25px"
});
var SkeletonTitle = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
    marginBottom: "6px"
});
var SkeletonSubTitle = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({});



/***/ }),

/***/ 65257:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "k": function() { return /* binding */ ErrorModal; },
  "C": function() { return /* binding */ ErrorModalTypes; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(45680);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/hooks/useSegment.ts
var useSegment = __webpack_require__(59945);
// EXTERNAL MODULE: ./src/hooks/useAuth.tsx + 4 modules
var useAuth = __webpack_require__(21566);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styled.js
var styled = __webpack_require__(13264);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
;// CONCATENATED MODULE: ./src/screens/checkout/paymentConfirm/styles/ErrorModal.styles.ts


var RootDiv = (0,styled/* default */.Z)("div")(function(param) {
    var theme = param.theme;
    return {
        width: "100vw",
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        height: "100vh",
        position: "fixed",
        background: " rgba(0,0,0,0.3)",
        zIndex: 4001,
        top: 0,
        right: 0,
        left: 0,
        color: theme.palette.primary.dark,
        "@media (min-width: 900px)": {
            justifyContent: "center"
        }
    };
});
var ModalDiv = (0,styled/* default */.Z)("div")({
    width: "95%",
    maxWidth: "336px",
    height: "auto",
    backgroundColor: "#FFFFFF",
    borderRadius: "10px",
    border: "1px solid #EAEAEA",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 4002,
    padding: "40px 0",
    marginTop: "83px",
    "@media (min-width: 900px)": {
        marginTop: 0
    }
});
var ErrorImg = (0,styled/* default */.Z)("img")({
    width: "38.67px",
    maxWidth: "200px",
    height: "auto",
    marginBottom: "17px"
});
var ErrorTitleTypography = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontFamily: "Poppins",
    fontWeight: 600,
    fontSize: "17px",
    lineHeight: "25.5px",
    textAlign: "center",
    letterSpacing: "0.15px",
    color: "#414046",
    margin: "0 70px 12px 70px"
});
var ErrorSubtitleTypography = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontFamily: "Poppins",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "21px",
    textAlign: "center",
    letterSpacing: "0.15px",
    color: "#414046",
    margin: "0 50px 30px 50px",
    span: {
        color: "#0277BD",
        cursor: "pointer",
        textDecoration: "underline"
    }
});
var ErrorButton = (0,styled/* default */.Z)("div")({
    height: "auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#0A7ABE",
    borderRadius: "100px",
    padding: "9px 31px",
    cursor: "pointer"
});
var ErrorButtonTypography = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontFamily: "Poppins",
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "24px",
    letterSpacing: "0.15px",
    color: "#FFFFFF"
});
var LoaderContainer = (0,styled/* default */.Z)("div")({
    display: "flex",
    marginBottom: "15px"
});


// EXTERNAL MODULE: ./src/hooks/usePermissions.tsx + 1 modules
var usePermissions = __webpack_require__(18782);
// EXTERNAL MODULE: ./src/utils/index.ts + 3 modules
var utils = __webpack_require__(8881);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useLazyQuery.js
var useLazyQuery = __webpack_require__(73359);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(50319);
// EXTERNAL MODULE: ./src/queries/userInsurance/queries/getInsuranceQuote.ts
var getInsuranceQuote = __webpack_require__(90534);
// EXTERNAL MODULE: ./src/hooks/useOrderState.tsx
var useOrderState = __webpack_require__(778);
// EXTERNAL MODULE: ./src/queries/order/mutations/setCheckoutOrderData.tsx
var setCheckoutOrderData = __webpack_require__(43013);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/CircularProgress/CircularProgress.js + 1 modules
var CircularProgress = __webpack_require__(70754);
// EXTERNAL MODULE: ./src/config/environment.ts
var environment = __webpack_require__(60031);
;// CONCATENATED MODULE: ./src/screens/checkout/paymentConfirm/components/ErrorModal.tsx




















var ErrorModalTypes;
(function(ErrorModalTypes) {
    ErrorModalTypes["REGISTRY"] = "registryError";
    ErrorModalTypes["FINTOC"] = "fintocError";
    ErrorModalTypes["NOT_ALLOWED_ITEMS"] = "notAllowedItemsError";
    ErrorModalTypes["INVALID_INSURANCE"] = "invalidInsuranceError";
    ErrorModalTypes["DEFAULT"] = "default";
    ErrorModalTypes["NONE"] = "none";
})(ErrorModalTypes || (ErrorModalTypes = {}));
function ErrorModal(props) {
    var ref, ref1, ref2;
    var handleHideError = props.handleHideError, uuid = props.uuid, errorType = props.errorType, refetchOrder = props.refetchOrder;
    var registryError = errorType === ErrorModalTypes.REGISTRY;
    var fintocError = errorType === ErrorModalTypes.FINTOC;
    var notAllowedItemsError = errorType === ErrorModalTypes.NOT_ALLOWED_ITEMS;
    var invalidInsuranceError = errorType === ErrorModalTypes.INVALID_INSURANCE;
    var ref3 = (0,useAuth/* useAuth */.a)(), user = ref3.appUser;
    var userCan = (0,usePermissions/* usePermissions */.T)().userCan;
    var track = (0,useSegment/* useSegment */.K)().track;
    var router = (0,next_router.useRouter)();
    var ref4 = (0,useOrderState/* useOrderState */.h)(), currentOrder = ref4.order;
    var isLocalVendor = userCan("LOCAL_VENDOR");
    var ref5;
    var id = (ref5 = uuid === null || uuid === void 0 ? void 0 : uuid.slice(0, 6).toUpperCase()) !== null && ref5 !== void 0 ? ref5 : "";
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,useLazyQuery/* useLazyQuery */.t)((0,getInsuranceQuote/* getInsuranceQuote */.H)(), {
        fetchPolicy: "network-only"
    }), 2), getInsuranceQuoteLazy = ref6[0], loading = ref6[1].loading;
    var ref7 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)((0,setCheckoutOrderData/* setCheckoutOrderData */.r)()), 1), setCheckoutData = ref7[0];
    var ref8, ref9, ref10;
    var currentOrderPaymentInformation = {
        useMekiCredits: currentOrder.metadata.useMekiCredits,
        chargeDeliveryCost: currentOrder.metadata.chargeDeliveryCost,
        localVendor: {
            paymentMethod: (ref8 = (ref = currentOrder.metadata.localVendor) === null || ref === void 0 ? void 0 : ref.paymentMethod) !== null && ref8 !== void 0 ? ref8 : null,
            mixPayments: (ref9 = (ref1 = currentOrder.metadata.localVendor) === null || ref1 === void 0 ? void 0 : ref1.mixPayments) !== null && ref9 !== void 0 ? ref9 : null
        },
        assistantVendor: {
            paymentMethod: (ref10 = (ref2 = currentOrder.metadata.assistantVendor) === null || ref2 === void 0 ? void 0 : ref2.paymentMethod) !== null && ref10 !== void 0 ? ref10 : null
        },
        sendEmail: currentOrder.metadata.sendEmail,
        userInfo: currentOrder.metadata.userInfo,
        installments: currentOrder.metadata.installments
    };
    var handleRefreshQuote = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, ref1, ref2, response, newQuoteInfo, cleanReimbursedProducts, ref3, ref4, ref5, ref6, ref7, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            getInsuranceQuoteLazy({
                                variables: {
                                    params: {
                                        rut: currentOrder.metadata.insuranceInfo.rut
                                    }
                                }
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        newQuoteInfo = (ref = response.data) === null || ref === void 0 ? void 0 : ref.getInsuranceQuote;
                        cleanReimbursedProducts = newQuoteInfo === null || newQuoteInfo === void 0 ? void 0 : (ref1 = newQuoteInfo.reimbursedProducts) === null || ref1 === void 0 ? void 0 : ref1.map(function(product) {
                            if (product.coverage) {
                                return {
                                    sku: +product.sku,
                                    observation: product.observation,
                                    unitReimbursement: product.unitReimbursement,
                                    unitDeductible: product.unitDeductible,
                                    unitCopay: product.unitCopay,
                                    coverage: product.coverage,
                                    quantity: product.quantity
                                };
                            }
                        });
                        return [
                            4,
                            setCheckoutData({
                                variables: {
                                    params: {
                                        orderId: currentOrder.id,
                                        replace: true,
                                        metadata: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, currentOrderPaymentInformation), {
                                            insuranceInfo: {
                                                claimId: (ref3 = +(newQuoteInfo === null || newQuoteInfo === void 0 ? void 0 : newQuoteInfo.claimId)) !== null && ref3 !== void 0 ? ref3 : null,
                                                rut: (ref4 = newQuoteInfo === null || newQuoteInfo === void 0 ? void 0 : (ref2 = newQuoteInfo.metadata) === null || ref2 === void 0 ? void 0 : ref2.rut) !== null && ref4 !== void 0 ? ref4 : "",
                                                insuranceId: (ref5 = newQuoteInfo === null || newQuoteInfo === void 0 ? void 0 : newQuoteInfo.insuranceId) !== null && ref5 !== void 0 ? ref5 : null,
                                                totalReimbursement: (ref6 = newQuoteInfo === null || newQuoteInfo === void 0 ? void 0 : newQuoteInfo.totalReimbursement) !== null && ref6 !== void 0 ? ref6 : 0,
                                                totalDeductible: (ref7 = newQuoteInfo === null || newQuoteInfo === void 0 ? void 0 : newQuoteInfo.totalDeductible) !== null && ref7 !== void 0 ? ref7 : 0,
                                                reimbursedProducts: cleanReimbursedProducts !== null && cleanReimbursedProducts !== void 0 ? cleanReimbursedProducts : []
                                            }
                                        })
                                    }
                                }
                            })
                        ];
                    case 2:
                        _state.sent();
                        refetchOrder !== null && refetchOrder !== void 0 ? refetchOrder : refetchOrder();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        void router.push(isLocalVendor ? (0,utils/* getRoute */.Bv)("checkoutPaymentMethodLocal") : (0,utils/* getRoute */.Bv)("checkoutPaymentMethod"));
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleRefreshQuote() {
            return _ref.apply(this, arguments);
        };
    }();
    var onActionClick = function() {
        if (registryError) {
            void track("add payment error contact", {
                userId: user === null || user === void 0 ? void 0 : user.id,
                error: "registry error",
                paymentMethodType: fintocError ? "FINTOC" : "ONE PAY"
            });
        } else {
            void track("payment error contact", {
                userId: user === null || user === void 0 ? void 0 : user.id,
                error: "other error",
                paymentMethodType: fintocError ? "FINTOC" : "ONE PAY"
            });
        }
        window.open("https://api.whatsapp.com/send?phone=".concat(environment/* PHONE_NUMBER.CLEAN */.UE.CLEAN, "&text=").concat(encodeURI("Hola! Tengo problemas en pagar mi compra. El n\xfamero de mi orden es ".concat(id, "."))), "_blank");
    };
    var onButtonClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (notAllowedItemsError) {
                            void router.push((0,utils/* getRoute */.Bv)("home", {
                                s: "open"
                            }));
                            return [
                                2
                            ];
                        }
                        if (!invalidInsuranceError) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            handleRefreshQuote()
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        handleHideError();
                        return [
                            2
                        ];
                }
            });
        });
        return function onButtonClick() {
            return _ref.apply(this, arguments);
        };
    }();
    var defaultSubtitle = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            "Intenta nuevamente, prueba con otro m\xe9todo de pago o",
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                onClick: onActionClick,
                children: "cont\xe1ctanos para ayudarte"
            })
        ]
    });
    var _obj;
    var errorTexts = (_obj = {}, (0,_define_property/* default */.Z)(_obj, ErrorModalTypes.REGISTRY, {
        title: "Hubo un problema registrando tu tarjeta",
        subtitle: defaultSubtitle
    }), (0,_define_property/* default */.Z)(_obj, ErrorModalTypes.FINTOC, {
        title: "Hubo un problema y no se realiz\xf3 el pago",
        subtitle: defaultSubtitle
    }), (0,_define_property/* default */.Z)(_obj, ErrorModalTypes.NOT_ALLOWED_ITEMS, {
        title: isLocalVendor ? "Algunos productos ya no estan disponibles" : "Se actualiz\xf3 tu carro",
        subtitle: isLocalVendor ? "Se actualiz\xf3 la orden. Revisa el carrito y vuelve a intentar" : "Revisa tus productos e intenta nuevamente"
    }), (0,_define_property/* default */.Z)(_obj, ErrorModalTypes.INVALID_INSURANCE, {
        title: "Se actualiz\xf3 el aporte de tu seguro",
        subtitle: "Revisa la nueva cobertura e intenta nuevamente"
    }), (0,_define_property/* default */.Z)(_obj, ErrorModalTypes.DEFAULT, {
        title: "Hubo un problema y no se realiz\xf3 el pago",
        subtitle: defaultSubtitle
    }), _obj);
    (0,react.useEffect)(function registryError() {
        if (registryError) {
            void track("add payment error", {
                userId: user === null || user === void 0 ? void 0 : user.id,
                error: "registry error",
                paymentMethodType: fintocError ? "FINTOC" : "ONE PAY"
            });
        } else {
            void track("payment error", {
                userId: user === null || user === void 0 ? void 0 : user.id,
                error: "registry error",
                paymentMethodType: fintocError ? "FINTOC" : "ONE PAY"
            });
        }
    }, [
        fintocError,
        registryError,
        track,
        user === null || user === void 0 ? void 0 : user.id
    ]);
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(RootDiv, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalDiv, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LoaderContainer, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                            size: 30,
                            color: "info"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorTitleTypography, {
                        children: "Actualizando seguro..."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorSubtitleTypography, {
                        children: "Por favor, espera un momento"
                    })
                ]
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RootDiv, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalDiv, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorImg, {
                    src: "/assets/images/warningIcon.png"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorTitleTypography, {
                    children: errorTexts[errorType].title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorSubtitleTypography, {
                    children: errorTexts[errorType].subtitle
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorButton, {
                    onClick: onButtonClick,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorButtonTypography, {
                        children: notAllowedItemsError ? "Ver productos" : "Volver a intentar"
                    })
                })
            ]
        })
    });
}


/***/ }),

/***/ 51798:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ CardIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_icons_VisaIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(683);
/* harmony import */ var _styles_PaymentsOptions_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4654);
/* harmony import */ var _components_icons_MasterCardIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27064);
/* harmony import */ var _components_icons_RedCompraIcon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1991);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_5__);






function CardIcon(props) {
    var icon;
    switch(props.creditCardType){
        case "Visa":
            icon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icons_VisaIcon__WEBPACK_IMPORTED_MODULE_1__/* .VisaIcon */ .Q, {});
            break;
        case "MasterCard":
            icon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icons_MasterCardIcon__WEBPACK_IMPORTED_MODULE_3__/* .MasterCardIcon */ .s, {});
            break;
        case "RedCompra":
            icon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icons_RedCompraIcon__WEBPACK_IMPORTED_MODULE_4__/* .RedCompraIcon */ .b, {});
            break;
        case "Fintoc":
            icon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_5___default()), {
                src: "/assets/images/bankIcon.png",
                alt: "bankIcon",
                height: 30,
                width: 30
            });
            break;
        case "BancoEstado":
            icon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_5___default()), {
                src: "/assets/images/bancoEstadoLogo.png",
                alt: "bancoEstadoLogo",
                height: 30,
                width: 30
            });
            break;
        default:
            icon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_5___default()), {
                src: "/assets/images/cardIcon.png",
                alt: "bankIcon",
                height: 30,
                width: 30
            });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles_PaymentsOptions_styles__WEBPACK_IMPORTED_MODULE_2__/* .CardIconContainer */ .gM, {
        children: icon
    });
}


/***/ }),

/***/ 54955:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ PaymentFooter; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _styles_PaymentFooter_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56837);
/* harmony import */ var _hooks_useModalRouter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9006);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8881);
/* harmony import */ var _zustand_paymentMethodStore__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69355);
/* harmony import */ var _config_environment__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(60031);
/* harmony import */ var _hooks_useAuth__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21566);
/* harmony import */ var _utils_formatters_CurrencyFormatter__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(23239);









var PaymentFooter = function(props) {
    var payAmount = props.payAmount, userHasInsurances = props.userHasInsurances, quoteLoading = props.quoteLoading, showNextButton = props.showNextButton;
    var ref = (0,_hooks_useAuth__WEBPACK_IMPORTED_MODULE_6__/* .useAuth */ .a)(), user = ref.appUser;
    var modalRouter = (0,_hooks_useModalRouter__WEBPACK_IMPORTED_MODULE_2__/* .useModalRouter */ .r)();
    var ref1;
    var isPermittedUser = !_config_environment__WEBPACK_IMPORTED_MODULE_5__/* .INSURANCE_EMAILS_ALLOWED */ .Ii ? true : _config_environment__WEBPACK_IMPORTED_MODULE_5__/* .INSURANCE_EMAILS_ALLOWED.includes */ .Ii.includes((ref1 = user === null || user === void 0 ? void 0 : user.email) !== null && ref1 !== void 0 ? ref1 : "");
    var ref2 = (0,_zustand_paymentMethodStore__WEBPACK_IMPORTED_MODULE_4__/* .useOrderAndPaymentInfo */ .oF)(), originalAmount = ref2.ordersTotal;
    var handleCreateInsurance = function() {
        void modalRouter.push((0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .getRoute */ .Bv)("insuranceIntroduction", {
            from: "checkout",
            redirect: "checkoutPaymentMethod"
        }));
    };
    var currencyFormatter = new _utils_formatters_CurrencyFormatter__WEBPACK_IMPORTED_MODULE_7__/* .CurrencyFormatter */ .J({
        fallback: _config_environment__WEBPACK_IMPORTED_MODULE_5__/* .NEXT_PUBLIC_NO_PRICE_FALLBACK */ .uh
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styles_PaymentFooter_styles__WEBPACK_IMPORTED_MODULE_1__/* .PaymentMethodFooterMain */ .B4, {
        showNextButton: showNextButton,
        children: [
            !userHasInsurances && isPermittedUser && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styles_PaymentFooter_styles__WEBPACK_IMPORTED_MODULE_1__/* .AddInsuranceContainer */ .rK, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles_PaymentFooter_styles__WEBPACK_IMPORTED_MODULE_1__/* .AddInsuranceTypography */ .ed, {
                                children: "\xbfTienes seguro?"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles_PaymentFooter_styles__WEBPACK_IMPORTED_MODULE_1__/* .AddInsuranceTypography */ .ed, {
                                underline: true,
                                onClick: handleCreateInsurance,
                                children: "Inscr\xedbelo aqu\xed"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles_PaymentFooter_styles__WEBPACK_IMPORTED_MODULE_1__/* .HorizontalLine */ .fu, {
                        width: 95
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styles_PaymentFooter_styles__WEBPACK_IMPORTED_MODULE_1__/* .PayAmountContainer */ .Iy, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles_PaymentFooter_styles__WEBPACK_IMPORTED_MODULE_1__/* .PayAmountTypography */ .Yd, {
                        children: "Total a pagar:"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styles_PaymentFooter_styles__WEBPACK_IMPORTED_MODULE_1__/* .AmountContainer */ .jp, {
                        children: [
                            originalAmount != payAmount && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles_PaymentFooter_styles__WEBPACK_IMPORTED_MODULE_1__/* .PayAmountDiscountTypography */ .db, {
                                children: currencyFormatter.format(originalAmount)
                            }),
                            quoteLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles_PaymentFooter_styles__WEBPACK_IMPORTED_MODULE_1__/* .SkeletonTotalPriceText */ .Fh, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles_PaymentFooter_styles__WEBPACK_IMPORTED_MODULE_1__/* .PayAmountTypography */ .Yd, {
                                children: payAmount == 0 ? "$0" : currencyFormatter.format(payAmount)
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 69221:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "VL": function() { return /* reexport */ InsuranceOptions; },
  "a_": function() { return /* reexport */ LoadingScreen; },
  "Pn": function() { return /* reexport */ MekiCredits; },
  "kE": function() { return /* reexport */ PaymentFooter/* PaymentFooter */.k; },
  "HT": function() { return /* reexport */ PaymentSwitch; },
  "Cn": function() { return /* reexport */ PaymentsOptions; }
});

// UNUSED EXPORTS: AddMethodMessage, AssistantPaymentOptions, InsuranceButton, LocalPaymentOptions, PaymentMethods

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styled.js
var styled = __webpack_require__(13264);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/InfoOutlined.js
var InfoOutlined = __webpack_require__(2548);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
;// CONCATENATED MODULE: ./src/screens/checkout/paymentMethod/styles/AddMethodMessage.styles.ts



var AddMethodMessage_styles_RootDiv = (0,styled/* default */.Z)("div")({
    display: "flex",
    margin: "17px 0 0px 0",
    padding: "6px 15px 6px 9px",
    alignItems: "center",
    backgroundColor: "#E6F3FA"
});
var AddMethodMessage_styles_InfoIcon = (0,styled/* default */.Z)(InfoOutlined/* default */.Z)({
    color: "##414046",
    fontSize: "22px"
});
var AddMethodMessage_styles_InfoText = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontFamily: "Poppins",
    fontWeight: "400",
    fontSize: "12px",
    lineHeight: "15.6px",
    letterSpacing: "0.15px",
    color: "#414046",
    marginLeft: "12px"
});


;// CONCATENATED MODULE: ./src/screens/checkout/paymentMethod/components/AddMethodMessage.tsx


function AddMethodMessage() {
    return /*#__PURE__*/ _jsxs(RootDiv, {
        children: [
            /*#__PURE__*/ _jsx(InfoIcon, {}),
            /*#__PURE__*/ _jsx(InfoText, {
                children: "Se cobrar\xe1 un monto de $50 para registrar la tarjeta. Este ser\xe1 devuelto de forma autom\xe1tica."
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/screens/checkout/paymentMethod/styles/LocalPaymentOptions.styles.ts


var LocalPaymentOptions_styles_RootDiv = (0,styled/* default */.Z)("div")({
    display: "flex",
    flexDirection: "column",
    margin: "12px 0 0 0",
    backgroundColor: "#FFFFFF",
    padding: "12px 15px",
    border: "1px solid #EAEAEA",
    borderRadius: "10px"
});
var HorizontalLineFull = (0,styled/* default */.Z)("div")({
    width: "calc(100% + 30px)",
    margin: "12px 0 12px -15px",
    height: "1px",
    backgroundColor: "#EAEAEA"
});
var AddOptionText = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontFamily: "Poppins",
    fontWeight: "500",
    fontSize: "13px",
    lineHeight: "19.5px",
    letterSpacing: "0.16px",
    color: "#0A7ABE",
    marginLeft: "27px"
});
var LocalTitleText = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontFamily: "Poppins",
    fontWeight: "600",
    fontSize: "16px",
    lineHeight: "24px",
    letterSpacing: "0.15px",
    color: "#414046"
});
var SelectPayment = (0,styled/* default */.Z)("select")({
    maxWidth: "306px",
    height: "40px",
    fontFamily: "Poppins",
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "19.5px",
    letterSpacing: "0.15px",
    color: "#757475",
    padding: "7px 0 7px 10px"
});
var SelectPaymentOption = (0,styled/* default */.Z)("option")({
    fontFamily: "Poppins",
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "19.5px",
    letterSpacing: "0.15px",
    color: "#757475",
    padding: "7px 0 7px 10px",
    cursor: "pointer",
    "&:hover": {
        backgroundColor: "#0A7ABE",
        color: "black"
    }
});
var TransferDiv = (0,styled/* default */.Z)("div")({
    backgroundColor: "#F9F9F9",
    padding: "15px 12px",
    maxWidth: "304px",
    marginTop: "10px"
});
var TransferTitleText = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontFamily: "Poppins",
    fontWeight: "500",
    fontSize: "14px",
    lineHeight: "19.5px",
    letterSpacing: "0.15px",
    color: "#414046",
    marginBottom: "6px"
});
var TransferText = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontFamily: "Poppins",
    fontWeight: "400",
    fontSize: "13px",
    lineHeight: "19.5px",
    letterSpacing: "0.15px",
    color: "#414046"
});
var MixDiv = (0,styled/* default */.Z)("div")({
    display: "flex",
    maxWidth: "304px",
    flexDirection: "row",
    marginTop: "10px",
    alignItems: "center",
    justifyContent: "space-between"
});
var MixText = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontFamily: "Poppins",
    fontWeight: "600",
    fontSize: "13px",
    lineHeight: "19.5px",
    letterSpacing: "0.16px",
    color: "#414046"
});
var MixInput = (0,styled/* default */.Z)("input")({
    maxWidth: "152px",
    padding: "10px",
    fontFamily: "Poppins",
    fontWeight: "400",
    fontSize: "13px",
    lineHeight: "19.5px",
    letterSpacing: "0.15px",
    color: "#414046",
    textAlign: "right"
});
var MixAmount = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontFamily: "Poppins",
    fontWeight: "500",
    fontSize: "13px",
    lineHeight: "19.5px",
    letterSpacing: "0.16px",
    color: "#757475"
});
var TotalTypography = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontFamily: "Poppins",
    marginTop: "10px",
    marginLeft: "5px",
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "18px",
    letterSpacing: "0.16px",
    color: "#757475",
    textAlign: "right"
});


// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ./src/interfaces/index.ts + 2 modules
var interfaces = __webpack_require__(95790);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/screens/checkout/paymentMethod/styles/PaymentsOptions.styles.ts
var PaymentsOptions_styles = __webpack_require__(4654);
// EXTERNAL MODULE: ./src/hooks/usePermissions.tsx + 1 modules
var usePermissions = __webpack_require__(18782);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ArrowForwardIosRounded.js
var ArrowForwardIosRounded = __webpack_require__(47111);
// EXTERNAL MODULE: ./src/screens/payment/methods/hooks/useOneClickRedirect.ts
var useOneClickRedirect = __webpack_require__(43472);
// EXTERNAL MODULE: ./src/screens/checkout/paymentMethod/components/CardIcon.tsx
var CardIcon = __webpack_require__(51798);
// EXTERNAL MODULE: ./src/screens/checkout/paymentMethod/zustand/paymentMethodStore.tsx
var paymentMethodStore = __webpack_require__(69355);
// EXTERNAL MODULE: ./src/screens/checkout/paymentConfirm/components/ErrorModal.tsx + 1 modules
var ErrorModal = __webpack_require__(65257);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/CircularProgress/CircularProgress.js + 1 modules
var CircularProgress = __webpack_require__(70754);
;// CONCATENATED MODULE: ./src/screens/checkout/paymentMethod/components/PaymentMethods.tsx













function PaymentMethods(param) {
    var loading = param.loading, handleSelect = param.handleSelect, quoteLoading = param.quoteLoading;
    var userCan = (0,usePermissions/* usePermissions */.T)().userCan;
    var isAssistantUser = userCan("MANAGE_USER");
    var ref = (0,react.useState)(false), error = ref[0], setError = ref[1];
    var ref1 = (0,react.useState)(false), loadingOneClick = ref1[0], setLoadingOneClick = ref1[1];
    var handleShowError = function() {
        setError(true);
    };
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useOneClickRedirect/* useOneClickRedirect */.O)("/checkout/metodo-pago", handleShowError), 1), redirectToOneClick = ref2[0];
    var paymentMethods = (0,paymentMethodStore/* useOrderAndPaymentInfo */.oF)().paymentMethods;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentsOptions_styles/* TitleText */.eN, {
                children: "Con tarjeta de cr\xe9dito/d\xe9bito"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PaymentsOptions_styles/* RootDiv */.of, {
                children: [
                    loading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PaymentsOptions_styles/* OptionDiv */.q4, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentsOptions_styles/* CardIconContainer */.gM, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(PaymentsOptions_styles/* SpaceBetweenContainer */.w7, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PaymentsOptions_styles/* TextDiv */.rk, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentsOptions_styles/* SkeletonOptionTitleText */.cu, {}),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentsOptions_styles/* SkeletonOptionDescriptionText */.Ey, {})
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentsOptions_styles/* ArrowIconContainer */.GF, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForwardIosRounded/* default */.Z, {
                                                    color: "primary"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }, 0),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HorizontalLineFull, {})
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: paymentMethods === null || paymentMethods === void 0 ? void 0 : paymentMethods.map(function(paymentMethod) {
                            if ((0,interfaces/* isPaymentMethodDataOneClick */.KR)(paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.data)) {
                                var ref;
                                var data = paymentMethod.data;
                                var typeCapitalize = paymentMethod.type === "ONE_CLICK" ? "Webpay OneClick" : (((ref = paymentMethod.type) === null || ref === void 0 ? void 0 : ref.replace(/_/g, "")) || "").replace(/^\w/, function(c) {
                                    return c.toUpperCase();
                                });
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(PaymentsOptions_styles/* OptionDiv */.q4, {
                                            quoteLoading: quoteLoading || loadingOneClick,
                                            onClick: function() {
                                                if (!loading && !quoteLoading) {
                                                    handleSelect(paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.uuid, paymentMethod);
                                                }
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CardIcon/* CardIcon */._, {
                                                    creditCardType: data.creditCardType
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(PaymentsOptions_styles/* SpaceBetweenContainer */.w7, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(PaymentsOptions_styles/* TextDiv */.rk, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(PaymentsOptions_styles/* OptionTitleText */.I3, {
                                                                    children: [
                                                                        data.creditCardType,
                                                                        " ",
                                                                        data.last4CardDigits.replace(/XXXXXXXXXXXX/g, "•••• ")
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentsOptions_styles/* OptionDescriptionText */.ex, {
                                                                    light: true,
                                                                    children: "".concat(typeCapitalize)
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentsOptions_styles/* ArrowIconContainer */.GF, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForwardIosRounded/* default */.Z, {
                                                                color: "primary"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HorizontalLineFull, {})
                                    ]
                                }, paymentMethod.id);
                            }
                        })
                    }),
                    !isAssistantUser && /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PaymentsOptions_styles/* OptionDiv */.q4, {
                            quoteLoading: quoteLoading,
                            onClick: function() {
                                setLoadingOneClick(true);
                                redirectToOneClick();
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CardIcon/* CardIcon */._, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(PaymentsOptions_styles/* SpaceBetweenContainer */.w7, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(PaymentsOptions_styles/* TextDiv */.rk, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentsOptions_styles/* OptionTitleText */.I3, {
                                                    children: "Nueva tarjeta"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentsOptions_styles/* OptionDescriptionText */.ex, {
                                                    light: true,
                                                    children: "Cr\xe9dito o d\xe9bito"
                                                })
                                            ]
                                        }),
                                        !loadingOneClick ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentsOptions_styles/* ArrowIconContainer */.GF, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForwardIosRounded/* default */.Z, {
                                                color: "primary"
                                            })
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentsOptions_styles/* NewCardLoaderContainer */.o3, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                                                size: 25,
                                                color: "primary"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            error && /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorModal/* ErrorModal */.k, {
                handleHideError: function() {
                    return setError(false);
                },
                uuid: "",
                errorType: ErrorModal/* ErrorModalTypes.REGISTRY */.C.REGISTRY
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/screens/checkout/paymentMethod/components/TransferDiv.tsx


var TransferDivComponent = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TransferDiv, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TransferTitleText, {
                children: "Datos transferencia"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TransferText, {
                children: "Nombre: MEDICAL KIT SPA"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TransferText, {
                children: "RUT: 77.143.138-0"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TransferText, {
                children: "Banco: BCI"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TransferText, {
                children: "Cuenta Cte N\xb0: 46193499"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TransferText, {
                children: "Correo electr\xf3nico: PAGOS@MIMEKI.CL"
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/screens/checkout/paymentMethod/zustand/localPaymentOptionsStore.tsx
var localPaymentOptionsStore = __webpack_require__(57500);
;// CONCATENATED MODULE: ./src/screens/checkout/paymentMethod/components/AssistantPaymentOptions.tsx





function AssistantPaymentOptions(props) {
    var loading = props.loading, handleSelect = props.handleSelect;
    var paymentOption = (0,localPaymentOptionsStore/* useLocalPaymentOption */.Z)().paymentOption;
    var setPaymentOption = (0,localPaymentOptionsStore/* useLocalPaymentOptionsActions */.e)().setPaymentOption;
    var handleOnChange = function(item) {
        setPaymentOption(item);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(LocalPaymentOptions_styles_RootDiv, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalTitleText, {
                children: "M\xe9todos de pago"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HorizontalLineFull, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SelectPayment, {
                placeholder: "Selecciona una opci\xf3n",
                onChange: function(item) {
                    return handleOnChange(item.target.value);
                },
                value: paymentOption,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectPaymentOption, {
                        hidden: true,
                        value: null,
                        children: "Selecciona una opci\xf3n"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectPaymentOption, {
                        value: "CARD",
                        children: "Tarjeta"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectPaymentOption, {
                        value: "TRANSFER",
                        children: "Transferencia"
                    })
                ]
            }),
            paymentOption === "TRANSFER" && /*#__PURE__*/ (0,jsx_runtime.jsx)(TransferDivComponent, {}),
            paymentOption === "CARD" && /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentMethods, {
                loading: loading,
                handleSelect: handleSelect
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/screens/checkout/paymentMethod/styles/InsuranceButton.styles.ts

var InsuranceButton_styles_RootDiv = (0,styled/* default */.Z)("div")({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#EFF7FF",
    padding: "15px 15px",
    border: "1px solid #0A7ABE",
    borderRadius: "10px",
    cursor: "pointer !important",
    marginTop: "15px"
});
var InsuranceButton_styles_InsuranceText = (0,styled/* default */.Z)("div")({
    fontFamily: "Poppins",
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "21px",
    letterSpacing: "0.16px",
    textAlign: "center",
    color: "#0A7ABE"
});


// EXTERNAL MODULE: ./src/hooks/useModalRouter.ts
var hooks_useModalRouter = __webpack_require__(9006);
// EXTERNAL MODULE: ./src/utils/index.ts + 3 modules
var utils = __webpack_require__(8881);
;// CONCATENATED MODULE: ./src/screens/checkout/paymentMethod/components/InsuranceButton.tsx




function InsuranceButton(props) {
    var disabled = props.disabled;
    var modalRouter = useModalRouter();
    var insuranceRedirect = function() {
        if (!disabled) {
            return void modalRouter.push(getRoute("insuranceInfo"));
        }
    };
    return /*#__PURE__*/ _jsx(RootDiv, {
        onClick: insuranceRedirect,
        children: /*#__PURE__*/ _jsx(InsuranceText, {
            children: "Inscribir seguro complementario"
        })
    });
}

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(45680);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Switch/Switch.js
var Switch = __webpack_require__(16056);
;// CONCATENATED MODULE: ./src/screens/checkout/paymentMethod/styles/InsuranceOptions.styles.ts




var InsuranceOptions_styles_RootDiv = (0,styled/* default */.Z)("div", {
    shouldForwardProp: function(prop) {
        return prop !== "hidden" && prop !== "childAmount";
    }
})(function(param) {
    var hidden = param.hidden, childAmount = param.childAmount, theme = param.theme;
    var _obj;
    return _obj = {
        display: "flex",
        flexDirection: "column",
        backgroundColor: "white",
        border: "1px solid #EAEAEA",
        borderRadius: "10px",
        height: hidden ? "0px" : "calc(84px + ".concat(childAmount, " * 64px)"),
        padding: hidden ? "0px 15px 0px 15px" : "15px 15px 8px 15px",
        opacity: hidden ? 0 : 1,
        marginTop: hidden ? "0px" : "15px",
        transition: "all 0.3s ease-in",
        "& > *": {
            opacity: hidden ? 0 : 1,
            transition: "all 0.3s ease-in"
        }
    }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.down(375), {
        height: hidden ? "0px" : "calc(63px + ".concat(childAmount, " * 84px)")
    }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.down(258), {
        height: hidden ? "0px" : "calc(87px + ".concat(childAmount, " * 84px)")
    }), _obj;
});
var InsuranceItem = (0,styled/* default */.Z)("div")({
    display: "flex",
    padding: "10px 0px",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between"
});
var InsuranceSubItem = (0,styled/* default */.Z)("div")({
    display: "flex",
    flexDirection: "row",
    justifyContent: "left",
    gap: "10px"
});
var TitleTypography = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontFamily: "Poppins",
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: "24px",
    letterSpacing: "0.16px",
    textAlign: "left"
});
var CheckIconContainer = (0,styled/* default */.Z)("div")({
    position: "relative",
    width: "24px",
    height: "24px",
    marginTop: "10px"
});
var InformationTypography = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "21px",
    letterSpacing: "0.16px",
    textAlign: "left",
    color: "#757475",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    transition: "color 0.3s ease-in-out"
});
var TextContainer = (0,styled/* default */.Z)("div")(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        display: "flex",
        flexDirection: "column",
        gap: "2px"
    }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.down(400), {
        maxWidth: "50vw"
    }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.down(300), {
        maxWidth: "40vw"
    }), _obj;
});
var SwitchButton = (0,styled/* default */.Z)(Switch/* default */.Z)({
    "& .MuiSwitch-switchBase.Mui-checked": {
        color: "#0A7ABE"
    },
    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
        backgroundColor: "#AFD5FF"
    }
});
var AddInsurance = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "21px",
    letterSpacing: "0.16px",
    color: "#0A7ABE",
    cursor: "pointer"
});
var AddInsuranceContainer = (0,styled/* default */.Z)("div")({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "1px",
    justifyContent: "flex-start",
    marginTop: "10px",
    marginBottom: "5px"
});
var IconContainer = (0,styled/* default */.Z)("div")({
    display: "flex",
    cursor: "pointer"
});
var LoaderContainer = (0,styled/* default */.Z)("div")({
    display: "flex",
    marginRight: 18
});
var InsuranceSkeletonContainer = (0,styled/* default */.Z)("div")({
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    marginTop: "15px"
});


// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Add.js
var Add = __webpack_require__(96540);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Divider/Divider.js
var Divider = __webpack_require__(44373);
// EXTERNAL MODULE: ./src/hooks/useAuth.tsx + 4 modules
var useAuth = __webpack_require__(21566);
// EXTERNAL MODULE: ./src/screens/checkout/delivery/styles/Delivery&PickUpContainer.styles.ts
var Delivery_PickUpContainer_styles = __webpack_require__(6577);
// EXTERNAL MODULE: ./src/config/environment.ts
var environment = __webpack_require__(60031);
// EXTERNAL MODULE: ./src/screens/insurance/my-insurances/styles.ts
var styles = __webpack_require__(47440);
// EXTERNAL MODULE: ./src/components/Reminders/reminderCardSkeleton.styles.ts
var reminderCardSkeleton_styles = __webpack_require__(19906);
// EXTERNAL MODULE: ./src/hooks/useMekiState.tsx + 1 modules
var useMekiState = __webpack_require__(48231);
;// CONCATENATED MODULE: ./src/screens/checkout/paymentMethod/components/InsuranceOptions.tsx


















function InsuranceOptions(props) {
    var loadingInsurances = props.loadingInsurances, loadInsuranceQuote = props.loadInsuranceQuote, loadingCircle = props.loadingCircle, userInsurances = props.userInsurances, quoteError = props.quoteError;
    var setMekiCreditsChecked = (0,paymentMethodStore/* usePaymentMethodActions */.pu)().setMekiCreditsChecked;
    var ref = (0,react.useState)(false), showLoader = ref[0], setShowLoader = ref[1];
    var ref1 = (0,react.useState)(null), insuranceClicked = ref1[0], setInsuranceClicked = ref1[1];
    var ref2 = (0,useMekiState/* useMekiState */.c)(), insuranceId = ref2.insuranceId, setInsuranceId = ref2.setInsuranceId, setInsuranceRut = ref2.setInsuranceRut;
    var ref3 = (0,useAuth/* useAuth */.a)(), user = ref3.appUser;
    var userCan = (0,usePermissions/* usePermissions */.T)().userCan;
    var modalRouter = (0,hooks_useModalRouter/* useModalRouter */.r)();
    var isLocalVendor = userCan("LOCAL_VENDOR");
    var ref4;
    var isPermittedUser = !environment/* INSURANCE_EMAILS_ALLOWED */.Ii ? true : environment/* INSURANCE_EMAILS_ALLOWED.includes */.Ii.includes((ref4 = user === null || user === void 0 ? void 0 : user.email) !== null && ref4 !== void 0 ? ref4 : "");
    var selectedInsurance = (0,react.useMemo)(function() {
        return userInsurances.find(function(insurance) {
            return insurance.id === insuranceId;
        });
    }, [
        userInsurances,
        insuranceId
    ]);
    var handleInsuranceChange = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var selected, err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if ((selectedInsurance === null || selectedInsurance === void 0 ? void 0 : selectedInsurance.id) === id) {
                            setInsuranceId(null);
                            setInsuranceClicked(null);
                            setMekiCreditsChecked(false);
                            return [
                                2
                            ];
                        }
                        setInsuranceClicked(id);
                        setShowLoader(true);
                        selected = userInsurances.find(function(insurance) {
                            return insurance.id === id;
                        });
                        if (!selected) return [
                            3,
                            5
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        setInsuranceId(id);
                        setMekiCreditsChecked(false);
                        setInsuranceRut(selected.rut);
                        return [
                            4,
                            loadInsuranceQuote(selected.rut)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 3:
                        err = _state.sent();
                        utils/* Console.error */.Mn.error("Error loading insurance quote:", err);
                        setInsuranceId(null);
                        setInsuranceClicked(null);
                        setMekiCreditsChecked(false);
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setShowLoader(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleInsuranceChange(id) {
            return _ref.apply(this, arguments);
        };
    }();
    var insuranceAmount = (0,react.useMemo)(function() {
        return (userInsurances === null || userInsurances === void 0 ? void 0 : userInsurances.length) || 0;
    }, [
        userInsurances
    ]);
    var insuranceRedirect = function() {
        if (isLocalVendor) {
            return void modalRouter.push((0,utils/* getRoute */.Bv)("insuranceIntroduction", {
                from: "checkout",
                redirect: "checkoutPaymentMethodLocal"
            }));
        }
        return void modalRouter.push((0,utils/* getRoute */.Bv)("insuranceIntroduction", {
            from: "checkout",
            redirect: "checkoutPaymentMethod"
        }));
    };
    if (!isPermittedUser) {
        return null;
    }
    if (!isLocalVendor && insuranceAmount === 0) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    var sortedUserInsurancesByDate = (0,react.useMemo)(function() {
        return userInsurances.sort(function(a, b) {
            return new Date(b.usedAt).getTime() - new Date(a.usedAt).getTime();
        });
    }, [
        userInsurances
    ]);
    (0,react.useEffect)(function() {
        if (quoteError) {
            setInsuranceId(null);
            setInsuranceClicked(null);
        }
    }, [
        quoteError
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !loadingInsurances ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(InsuranceOptions_styles_RootDiv, {
                hidden: false,
                childAmount: insuranceAmount,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleTypography, {
                        children: "Seguro complementario"
                    }),
                    sortedUserInsurancesByDate.map(function(insurance) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(InsuranceItem, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextContainer, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(InformationTypography, {
                                                    children: insurance.name
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(InformationTypography, {
                                                    children: insurance.rut
                                                })
                                            ]
                                        }),
                                        (showLoader || loadingCircle) && insuranceClicked === insurance.id ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LoaderContainer, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                                                size: 25,
                                                thickness: 4,
                                                color: "primary"
                                            })
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SwitchButton, {
                                            onChange: function() {
                                                void handleInsuranceChange(insurance.id);
                                            },
                                            checked: insuranceId && insuranceId === insurance.id
                                        })
                                    ]
                                }, insurance.id),
                                insuranceAmount != 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {})
                            ]
                        }, insurance.id);
                    }),
                    insuranceAmount >= 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            insuranceAmount == 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(AddInsuranceContainer, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconContainer, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Add/* default */.Z, {
                                            color: "primary",
                                            fontSize: "small"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Delivery_PickUpContainer_styles/* AddAddressTypography */.yy, {
                                        onClick: insuranceRedirect,
                                        children: "Agregar otro seguro/beneficiario"
                                    }),
                                    " "
                                ]
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(InsuranceSkeletonContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* SkeletonContainer */.Fh, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(reminderCardSkeleton_styles/* StyledSkeleton */.ps, {
                            variant: "rectangular",
                            width: "10%",
                            height: 10,
                            style: {
                                margin: 0
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(reminderCardSkeleton_styles/* StyledSkeleton */.ps, {
                            variant: "rectangular",
                            width: "30%",
                            height: 10,
                            style: {
                                margin: 0
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(reminderCardSkeleton_styles/* StyledSkeleton */.ps, {
                            variant: "rectangular",
                            width: "15%",
                            height: 10,
                            style: {
                                margin: 0
                            }
                        })
                    ]
                })
            }),
            quoteError && /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentsOptions_styles/* ErrorTypography */.Os, {
                children: "No se pudo obtener la cotizaci\xf3n del seguro. Intente m\xe1s tarde."
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/LinearProgress/LinearProgress.js + 1 modules
var LinearProgress = __webpack_require__(86070);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Button/Button.js + 3 modules
var Button = __webpack_require__(26993);
;// CONCATENATED MODULE: ./src/screens/checkout/paymentMethod/styles/LoadingScreen.styles.ts



var LoadingScreen_styles_RootDiv = (0,styled/* default */.Z)("div")({
    display: "flex",
    flexDirection: "column",
    height: "100vh",
    alignItems: "center",
    justifyContent: "center",
    "@media (min-width: 900px)": {
        height: "calc(100vh - 100px)"
    }
});
var LoadingText = (0,styled/* default */.Z)(Typography/* default */.Z)(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        fontFamily: "Poppins",
        fontWeight: 600,
        fontSize: "16px",
        lineHeight: "24px",
        letterSpacing: "0.15px",
        color: "#414046",
        textAlign: "center",
        margin: "0 100px 45px 100px"
    }, theme.breakpoints.up(900), {
        margin: "0 300px 45px 300px"
    });
});
var LoadingImg = (0,styled/* default */.Z)("img")({
    width: "47.24px",
    marginBottom: "45px"
});
var LoadingBar = (0,styled/* default */.Z)(LinearProgress/* default */.Z)({
    width: "40%",
    height: "4px",
    borderRadius: "2px",
    backgroundColor: "#E5E5E5",
    "@media (min-width: 900px)": {
        width: "25%"
    }
});
var CancelButton = (0,styled/* default */.Z)(Button/* default */.Z)(function(param) {
    var disabled = param.disabled;
    return {
        padding: "10px 20px",
        marginTop: "20px",
        cursor: "pointer",
        borderRadius: "100px",
        color: "#FFFFFF",
        height: "42px",
        width: "199px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    };
});
var CancelText = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontFamily: "Poppins",
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "24px",
    letterSpacing: "0.15px",
    textDecoration: "none",
    textTransform: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px"
});


;// CONCATENATED MODULE: ./src/screens/checkout/paymentMethod/components/LoadingScreen.tsx




function LoadingScreen(props) {
    var ref = (0,react.useState)(false), disabled = ref[0], setDisabled = ref[1];
    var redirectMessage = props.redirectMessage, isFintocSuccess = props.isFintocSuccess, showCancelButton = props.showCancelButton, handleCancel = props.handleCancel, isLocalVendor = props.isLocalVendor, isInsurance = props.isInsurance;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(LoadingScreen_styles_RootDiv, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingText, {
                children: isLocalVendor ? "Cargando..." : isFintocSuccess ? "Validando pago..." : redirectMessage ? "Redirigiendo..." : isInsurance ? "Confirmando..." : "Confirmando y realizando cobro..."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingImg, {
                src: "/assets/images/creditCard.png"
            }),
            !disabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingBar, {}),
            showCancelButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(CancelButton, {
                variant: "contained",
                onClick: function() {
                    if (!disabled) {
                        setDisabled(true);
                        handleCancel();
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CancelText, {
                    children: disabled ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            "Cancelando ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                                color: "inherit",
                                size: 20
                            })
                        ]
                    }) : "Cancelar"
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/utils/formatters/CurrencyFormatter.ts
var CurrencyFormatter = __webpack_require__(23239);
;// CONCATENATED MODULE: ./src/screens/checkout/paymentMethod/components/LocalPaymentOptions.tsx






function LocalPaymentOptions(props) {
    var changePaymentAmount = props.changePaymentAmount;
    var ref = (0,localPaymentOptionsStore/* useLocalPaymentOption */.Z)(), paymentOption = ref.paymentOption, mixPayments = ref.mixPayments;
    var setPaymentOption = (0,localPaymentOptionsStore/* useLocalPaymentOptionsActions */.e)().setPaymentOption;
    var handleOnChange = function(item) {
        setPaymentOption(item);
    };
    var currFormat = new CurrencyFormatter/* CurrencyFormatter */.J({
        fallback: environment/* NEXT_PUBLIC_NO_PRICE_FALLBACK */.uh
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(LocalPaymentOptions_styles_RootDiv, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalTitleText, {
                children: "M\xe9todos de pago"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HorizontalLineFull, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SelectPayment, {
                onChange: function(item) {
                    return handleOnChange(item.target.value);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectPaymentOption, {
                        value: "none",
                        selected: true,
                        disabled: true,
                        hidden: true,
                        children: "Seleccionar m\xe9todo de pago"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectPaymentOption, {
                        value: "CASH",
                        children: "Efectivo"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectPaymentOption, {
                        value: "CARD",
                        children: "Tarjeta"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectPaymentOption, {
                        value: "TRANSFER",
                        children: "Transferencia"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectPaymentOption, {
                        value: "CARD_CASH",
                        children: "Efectivo + Tarjeta"
                    })
                ]
            }),
            paymentOption === "TRANSFER" && /*#__PURE__*/ (0,jsx_runtime.jsx)(TransferDivComponent, {}),
            paymentOption === "CARD_CASH" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(MixDiv, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MixText, {
                                children: "Efectivo"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MixInput, {
                                value: mixPayments.CASH,
                                onChange: function(event) {
                                    return changePaymentAmount(event);
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(MixDiv, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MixText, {
                                children: "Tarjeta"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MixAmount, {
                                children: currFormat.format(mixPayments.CARD)
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Skeleton/Skeleton.js + 2 modules
var Skeleton = __webpack_require__(91655);
;// CONCATENATED MODULE: ./src/screens/checkout/paymentMethod/styles/MekiCredits.styles.ts



var MekiCredits_styles_RootDiv = (0,styled/* default */.Z)("div")({
    display: "flex",
    margin: "0 0 0 0",
    backgroundColor: "#FFFFFF",
    padding: "12px 15px",
    justifyContent: "space-between",
    border: "1px solid #EAEAEA",
    borderRadius: "10px",
    alignItems: "center"
});
var Text = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontSize: "12px",
    fontWeight: "500",
    fontFamily: "Poppins",
    lineHeight: "18px",
    letterSpacing: "0.16px",
    color: "#414046"
});
var MekiCredits_styles_SwitchButton = (0,styled/* default */.Z)(Switch/* default */.Z)({
    "& .MuiSwitch-switchBase.Mui-checked": {
        color: "#0A7ABE"
    },
    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
        backgroundColor: "#AFD5FF"
    }
});
var SkeletonText = (0,styled/* default */.Z)(Skeleton/* default */.Z)({
    width: "107px",
    height: "20px"
});
var SkeletonSwitch = (0,styled/* default */.Z)(Skeleton/* default */.Z)({
    width: "58px",
    height: "38px"
});


// EXTERNAL MODULE: ./src/hooks/useSegment.ts
var useSegment = __webpack_require__(59945);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useQuery.js
var useQuery = __webpack_require__(71641);
// EXTERNAL MODULE: ./src/queries/checkout/queries/paymentMethod.ts
var paymentMethod = __webpack_require__(66003);
// EXTERNAL MODULE: ./src/hooks/useOrderState.tsx
var useOrderState = __webpack_require__(778);
;// CONCATENATED MODULE: ./src/screens/checkout/paymentMethod/components/MekiCredits.tsx
// import { useEffect } from 'react';










function MekiCredits(props) {
    var loading = props.loading;
    var track = (0,useSegment/* useSegment */.K)().track;
    var orderState = (0,useOrderState/* useOrderState */.h)();
    var orderUuid = orderState.orderUuid;
    var ref = (0,paymentMethodStore/* usePaymentSelectors */.M6)(), checked = ref.mekiCreditsChecked;
    var setMekiCreditsChecked = (0,paymentMethodStore/* usePaymentMethodActions */.pu)().setMekiCreditsChecked;
    var setInsuranceId = (0,useMekiState/* useMekiState */.c)().setInsuranceId;
    var ref1 = (0,useQuery/* useQuery */.a)((0,paymentMethod/* getCheckoutPaymentMethod */.k)(), {
        fetchPolicy: "cache-first",
        variables: {
            params: {
                orderUuid: orderUuid
            }
        }
    }), orderAndUserInfoData = ref1.data;
    var currentUserInfo = (orderAndUserInfoData !== null && orderAndUserInfoData !== void 0 ? orderAndUserInfoData : {}).currentUserInfo;
    var ref2;
    var credits = (ref2 = currentUserInfo === null || currentUserInfo === void 0 ? void 0 : currentUserInfo.credits) !== null && ref2 !== void 0 ? ref2 : 0;
    var handleMekiCreditsChange = function(event) {
        setMekiCreditsChecked(event.target.checked);
        setInsuranceId(null);
        track("change credits use", {
            activated: event.target.checked
        });
    };
    var currencyFormatter = new CurrencyFormatter/* CurrencyFormatter */.J({
        fallback: environment/* NEXT_PUBLIC_NO_PRICE_FALLBACK */.uh
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MekiCredits_styles_RootDiv, {
        children: [
            loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonText, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text, {
                children: [
                    "Cr\xe9ditos Meki:",
                    " ",
                    credits === 0 ? "$0" : currencyFormatter.format(credits)
                ]
            }),
            loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonSwitch, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(MekiCredits_styles_SwitchButton, {
                onChange: handleMekiCreditsChange,
                checked: checked
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(50319);
// EXTERNAL MODULE: ./src/queries/checkout/mutations/assignPaymentMethod.tsx
var assignPaymentMethod = __webpack_require__(50952);
;// CONCATENATED MODULE: ./src/screens/checkout/paymentMethod/components/PaymentsOptions.tsx






















function PaymentsOptions(props) {
    var loading = props.loading, quoteLoading = props.quoteLoading, handleNext = props.handleNext;
    var ref = (0,useAuth/* useAuth */.a)(), user = ref.appUser;
    var userCan = (0,usePermissions/* usePermissions */.T)().userCan;
    var isLocalVendor = userCan("LOCAL_VENDOR");
    var isAssistantUser = userCan("MANAGE_USER");
    var areBancoEstadoEmailsAllowed = environment/* BANCO_ESTADO_EMAILS_ALLOWED.length */.Gr.length > 0;
    var ref1;
    var isPermittedUser = areBancoEstadoEmailsAllowed ? environment/* BANCO_ESTADO_EMAILS_ALLOWED.includes */.Gr.includes((ref1 = user === null || user === void 0 ? void 0 : user.email) !== null && ref1 !== void 0 ? ref1 : "") : true;
    var track = (0,useSegment/* useSegment */.K)().track;
    var orderState = (0,useOrderState/* useOrderState */.h)();
    var orderUuid = orderState.orderUuid, currentOrder = orderState.order;
    var ref2 = (0,paymentMethodStore/* useOrderAndPaymentInfo */.oF)(), orders = ref2.orders, ordersTotal = ref2.ordersTotal, paymentMethods = ref2.paymentMethods;
    var setMixPayments = (0,localPaymentOptionsStore/* useLocalPaymentOptionsActions */.e)().setMixPayments;
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)((0,assignPaymentMethod/* assignPaymentMethod */.n)()), 1), assignMethod = ref3[0];
    var ref4;
    var deliveryCost = (ref4 = orders === null || orders === void 0 ? void 0 : orders.reduce(function(acc, curr) {
        return acc + curr.deliveryCost;
    }, 0)) !== null && ref4 !== void 0 ? ref4 : 0;
    var changePaymentAmount = (0,react.useCallback)(function(event) {
        var valueToNumber = Number(event.target.value.replace("$", "").replace(/\./g, ""));
        if (Number.isInteger(+valueToNumber) && +valueToNumber <= ordersTotal - deliveryCost) {
            setMixPayments({
                CASH: +valueToNumber,
                CARD: ordersTotal - deliveryCost - +valueToNumber
            });
        }
    }, [
        deliveryCost,
        ordersTotal,
        setMixPayments
    ]);
    var handleSelect = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(e, paymentMethod, otherPaymentMethods) {
            var ref, uuid, intallmentsRedirect, e1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        uuid = otherPaymentMethods == interfaces/* OtherPaymentMethods.FINTOC */.pl.FINTOC ? "00000000-0000-0000-0000-00000001" : otherPaymentMethods == interfaces/* OtherPaymentMethods.BANCO_ESTADO */.pl.BANCO_ESTADO ? "00000000-0000-0000-0000-00000005" : paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.uuid;
                        return [
                            4,
                            assignMethod({
                                variables: {
                                    params: {
                                        orderUuid: orderUuid,
                                        paymentMethodUuid: uuid
                                    }
                                },
                                optimisticResponse: function optimisticResponse(param) {
                                    var paymentMethodUuid = param.params.paymentMethodUuid;
                                    var _$paymentMethod = paymentMethods.find(function(e) {
                                        return e.uuid === paymentMethodUuid;
                                    });
                                    return {
                                        assignPaymentMethod: {
                                            __typename: "Order",
                                            id: currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.id,
                                            uuid: orderUuid,
                                            paymentMethod: {
                                                id: otherPaymentMethods == interfaces/* OtherPaymentMethods.FINTOC */.pl.FINTOC ? -2 : otherPaymentMethods == interfaces/* OtherPaymentMethods.BANCO_ESTADO */.pl.BANCO_ESTADO ? -6 : _$paymentMethod.id
                                            }
                                        }
                                    };
                                }
                            })
                        ];
                    case 1:
                        _state.sent();
                        intallmentsRedirect = (paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.type) === "ONE_CLICK" && [
                            "Visa",
                            "MasterCard"
                        ].includes(paymentMethod === null || paymentMethod === void 0 ? void 0 : (ref = paymentMethod.data) === null || ref === void 0 ? void 0 : ref.creditCardType);
                        return [
                            4,
                            handleNext(intallmentsRedirect)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e1 = _state.sent();
                        utils/* Console.error */.Mn.error("CheckoutPaymentMethod: unhandled error", {
                            e: e1
                        });
                        utils/* Console.error */.Mn.error("CheckoutPaymentMethod: variables", {
                            paymentMethodUuid: paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.uuid,
                            orderUuid: orderUuid
                        });
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(e, paymentMethod, otherPaymentMethods) {
            return _ref.apply(this, arguments);
        };
    }(), [
        assignMethod,
        currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.id,
        handleNext,
        orderUuid,
        paymentMethods
    ]);
    (0,react.useEffect)(function handleSelectPaymentMethodEvent() {
        var ref;
        if (currentOrder === null || currentOrder === void 0 ? void 0 : (ref = currentOrder.paymentMethod) === null || ref === void 0 ? void 0 : ref.uuid) {
            void track("payment select", {
                payment_method_type: currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.paymentMethod.type
            });
        }
    }, [
        track,
        currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.paymentMethod
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isLocalVendor ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalPaymentOptions, {
                changePaymentAmount: changePaymentAmount
            }) : isAssistantUser ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AssistantPaymentOptions, {
                changePaymentAmount: changePaymentAmount,
                loading: loading,
                handleSelect: handleSelect
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentMethods, {
                loading: loading,
                quoteLoading: quoteLoading,
                handleSelect: handleSelect
            }),
            !isLocalVendor && !isAssistantUser && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentsOptions_styles/* TitleText */.eN, {
                        children: "Otro m\xe9todo de pago"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(PaymentsOptions_styles/* RootDiv */.of, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PaymentsOptions_styles/* OptionDiv */.q4, {
                                quoteLoading: quoteLoading,
                                onClick: function(event) {
                                    return void handleSelect(event, null, interfaces/* OtherPaymentMethods.FINTOC */.pl.FINTOC);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CardIcon/* CardIcon */._, {
                                        creditCardType: "Fintoc"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(PaymentsOptions_styles/* SpaceBetweenContainer */.w7, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PaymentsOptions_styles/* TextDiv */.rk, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentsOptions_styles/* OptionTitleText */.I3, {
                                                        children: "Directo con tu banco"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentsOptions_styles/* OptionDescriptionText */.ex, {
                                                        light: true,
                                                        children: "sin salir de la p\xe1gina"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentsOptions_styles/* ArrowIconContainer */.GF, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForwardIosRounded/* default */.Z, {
                                                    color: "primary"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            isPermittedUser && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentsOptions_styles/* HorizontalLineFull */.WO, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PaymentsOptions_styles/* OptionDiv */.q4, {
                                            quoteLoading: quoteLoading,
                                            onClick: function(event) {
                                                return void handleSelect(event, null, interfaces/* OtherPaymentMethods.BANCO_ESTADO */.pl.BANCO_ESTADO);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CardIcon/* CardIcon */._, {
                                                    creditCardType: "BancoEstado"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(PaymentsOptions_styles/* SpaceBetweenContainer */.w7, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(PaymentsOptions_styles/* TextDiv */.rk, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentsOptions_styles/* OptionTitleText */.I3, {
                                                                    children: "Banco Estado"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentsOptions_styles/* OptionDescriptionText */.ex, {
                                                                    light: true,
                                                                    children: "Compraqu\xed"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentsOptions_styles/* ArrowIconContainer */.GF, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForwardIosRounded/* default */.Z, {
                                                                color: "primary"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/screens/checkout/paymentMethod/zustand/assistantPaymentOptionsStore.tsx
var assistantPaymentOptionsStore = __webpack_require__(82031);
;// CONCATENATED MODULE: ./src/screens/checkout/paymentMethod/components/PaymentSwitch.tsx




function PaymentSwitch(param) {
    var label = param.label, loading = param.loading;
    var track = (0,useSegment/* useSegment */.K)().track;
    var ref = (0,assistantPaymentOptionsStore/* useAssistantPaymentOptions */.S)(), sendEmail = ref.sendEmail, chargeDeliveryCost = ref.chargeDeliveryCost;
    var checked = label == "Enviar email" ? sendEmail : chargeDeliveryCost;
    var ref1 = (0,assistantPaymentOptionsStore/* useAssistantPaymentActions */.M)(), setSendEmail = ref1.setSendEmail, setChargeDeliveryCost = ref1.setChargeDeliveryCost;
    var handleChangeSkipDeliveryCost = function(event) {
        setChargeDeliveryCost(event.target.checked);
        track("change charge delivery cost", {
            activated: event.target.checked
        });
    };
    var handleChangeSendEmail = function(event) {
        setSendEmail(event.target.checked);
        track("change send email", {
            activated: event.target.checked
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MekiCredits_styles_RootDiv, {
        children: [
            loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonText, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                children: label
            }),
            loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonSwitch, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(MekiCredits_styles_SwitchButton, {
                onChange: label == "Enviar email" ? handleChangeSendEmail : handleChangeSkipDeliveryCost,
                checked: checked
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/screens/checkout/paymentMethod/components/PaymentFooter.tsx
var PaymentFooter = __webpack_require__(54955);
;// CONCATENATED MODULE: ./src/screens/checkout/paymentMethod/components/index.tsx













/***/ }),

/***/ 56837:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B4": function() { return /* binding */ PaymentMethodFooterMain; },
/* harmony export */   "Fh": function() { return /* binding */ SkeletonTotalPriceText; },
/* harmony export */   "Iy": function() { return /* binding */ PayAmountContainer; },
/* harmony export */   "Yd": function() { return /* binding */ PayAmountTypography; },
/* harmony export */   "db": function() { return /* binding */ PayAmountDiscountTypography; },
/* harmony export */   "ed": function() { return /* binding */ AddInsuranceTypography; },
/* harmony export */   "fu": function() { return /* binding */ HorizontalLine; },
/* harmony export */   "jp": function() { return /* binding */ AmountContainer; },
/* harmony export */   "rK": function() { return /* binding */ AddInsuranceContainer; }
/* harmony export */ });
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13264);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29630);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91655);


var PaymentMethodFooterMain = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div", {
    shouldForwardProp: function(prop) {
        return prop !== "showNextButton";
    }
})(function(param) {
    var showNextButton = param.showNextButton;
    return {
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#FFFFFF",
        justifyContent: "center",
        alignContent: "center",
        alignItems: "center",
        position: "fixed",
        bottom: showNextButton ? "80px" : "0px",
        width: "100%",
        height: "fit-content",
        borderTop: "1px solid #EAEAEA",
        "@media (min-width: 900px)": {
            position: "sticky"
        },
        zIndex: 2
    };
});
var PayAmountTypography = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    fontFamily: "Poppins",
    fontSize: "13px",
    fontWeight: 600,
    lineHeight: "19px",
    color: "#414046"
});
var PayAmountDiscountTypography = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(PayAmountTypography)({
    fontWeight: 400,
    color: "#757475",
    textDecoration: "line-through",
    marginRight: "8px"
});
var PayAmountContainer = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div")({
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
    padding: "16px 16px"
});
var AddInsuranceTypography = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
    shouldForwardProp: function(prop) {
        return prop !== "underline";
    }
})(function(param) {
    var underline = param.underline;
    return {
        fontFamily: "Poppins",
        fontSize: "12px",
        fontWeight: 500,
        lineHeight: "18px",
        color: underline ? "#0277BD" : "#414046",
        cursor: underline ? "pointer" : "default",
        textDecoration: underline ? "underline" : "none"
    };
});
var AddInsuranceContainer = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div")({
    gap: "4px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "left",
    padding: "12px 16px",
    width: "100%"
});
var HorizontalLine = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div", {
    shouldForwardProp: function(prop) {
        return prop !== "width";
    }
})(function(param) {
    var width = param.width;
    return {
        width: width ? "".concat(width, "%") : "100%",
        height: "1px",
        backgroundColor: "#EAEAEA"
    };
});
var AmountContainer = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div")({
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
});
var SkeletonTotalPriceText = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    width: "42px",
    height: "20px",
    borderRadius: "4px"
});



/***/ }),

/***/ 4654:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ey": function() { return /* binding */ SkeletonOptionDescriptionText; },
/* harmony export */   "GF": function() { return /* binding */ ArrowIconContainer; },
/* harmony export */   "I3": function() { return /* binding */ OptionTitleText; },
/* harmony export */   "Os": function() { return /* binding */ ErrorTypography; },
/* harmony export */   "PM": function() { return /* binding */ InstallmentsText; },
/* harmony export */   "WO": function() { return /* binding */ HorizontalLineFull; },
/* harmony export */   "cu": function() { return /* binding */ SkeletonOptionTitleText; },
/* harmony export */   "eN": function() { return /* binding */ TitleText; },
/* harmony export */   "ex": function() { return /* binding */ OptionDescriptionText; },
/* harmony export */   "gM": function() { return /* binding */ CardIconContainer; },
/* harmony export */   "o3": function() { return /* binding */ NewCardLoaderContainer; },
/* harmony export */   "of": function() { return /* binding */ RootDiv; },
/* harmony export */   "q4": function() { return /* binding */ OptionDiv; },
/* harmony export */   "rk": function() { return /* binding */ TextDiv; },
/* harmony export */   "w7": function() { return /* binding */ SpaceBetweenContainer; }
/* harmony export */ });
/* unused harmony exports RadioInput, AddOptionText, RadioInputSkeleton */
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13264);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29630);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91655);


var RootDiv = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div")({
    display: "flex",
    flexDirection: "column",
    margin: "12px 0 12px 0",
    backgroundColor: "#FFFFFF",
    padding: "12px 15px",
    border: "1px solid #EAEAEA",
    borderRadius: "10px",
    zIndex: 1
});
var TitleText = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    fontFamily: "Poppins",
    fontWeight: "600",
    fontSize: "14px",
    lineHeight: "21px",
    letterSpacing: "0.15px",
    color: "#414046",
    margin: "17px 0 0 15px"
});
var HorizontalLineFull = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div")({
    width: "calc(100% + 30px)",
    margin: "12px 0 12px -15px",
    height: "1px",
    backgroundColor: "#EAEAEA"
});
var OptionDiv = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div", {
    shouldForwardProp: function(prop) {
        return prop !== "quoteLoading";
    }
})(function(param) {
    var quoteLoading = param.quoteLoading;
    return {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        marginLeft: "10px",
        cursor: quoteLoading ? "default" : "pointer !important",
        opacity: quoteLoading ? 0.5 : 1
    };
});
var RadioInput = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("input")({
    cursor: "pointer",
    WebkitAppearance: "none",
    width: "20px",
    height: "20px",
    borderRadius: "50%",
    outline: "none",
    border: "2px solid #0277BD",
    ":before": {
        content: '""',
        display: "block",
        width: "60%",
        height: "60%",
        margin: "20% auto",
        borderRadius: "50%"
    },
    ":checked:before": {
        backgroundColor: "#0277BD"
    }
});
var RadioInputSkeleton = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    width: "20px",
    height: "30px"
});
var TextDiv = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div")({
    display: "flex",
    flexDirection: "column",
    marginLeft: "27px"
});
var OptionTitleText = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    fontFamily: "Poppins",
    fontWeight: "500",
    fontSize: "12px",
    lineHeight: "18px",
    letterSpacing: "0.16px",
    color: "#414046"
});
var InstallmentsText = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    fontFamily: "Poppins",
    fontWeight: "300",
    fontSize: "12px",
    lineHeight: "18px",
    letterSpacing: "0.16px",
    color: "#919191",
    "> span": {
        marginLeft: "5px",
        color: "#414046",
        fontWeight: "500"
    }
});
var SkeletonOptionTitleText = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    width: "120px",
    height: "20px"
});
var OptionDescriptionText = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
    shouldForwardProp: function(prop) {
        return prop !== "light";
    }
})(function(param) {
    var light = param.light;
    return {
        fontFamily: "Poppins",
        fontWeight: light ? "300" : "500",
        fontSize: "12px",
        lineHeight: "18px",
        letterSpacing: "0.16px",
        color: "#919191"
    };
});
var SkeletonOptionDescriptionText = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    width: "80px",
    height: "20px"
});
var AddOptionText = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    fontFamily: "Poppins",
    fontWeight: "500",
    fontSize: "13px",
    lineHeight: "19.5px",
    letterSpacing: "0.16px",
    color: "#0A7ABE",
    marginLeft: "27px"
});
var ErrorTypography = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    fontFamily: "Poppins",
    fontWeight: 500,
    fontSize: "12px",
    lineHeight: "16px",
    letterSpacing: "0.15px",
    color: "#D32F2F",
    marginTop: "6px",
    marginBottom: "6px"
});
var CardIconContainer = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div")({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "35px",
    height: "35px",
    borderRadius: "50%",
    backgroundColor: "#EAEAEA"
});
var ArrowIconContainer = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div")({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "35px",
    height: "35px"
});
var SpaceBetweenContainer = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div")({
    display: "flex",
    flex: 1,
    flexDirection: "row",
    justifyContent: "space-between"
});
var NewCardLoaderContainer = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div")({
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#FFFFFF",
    justifyContent: "center",
    marginRight: "5px",
    borderRadius: "10px",
    zIndex: 1
});



/***/ }),

/***/ 82031:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ useAssistantPaymentActions; },
/* harmony export */   "S": function() { return /* binding */ useAssistantPaymentOptions; }
/* harmony export */ });
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64529);

var useAssistantPaymentOptionsStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* .create */ .Ue)()(function(set) {
    return {
        sendEmail: true,
        chargeDeliveryCost: true,
        actions: {
            setSendEmail: function(to) {
                set({
                    sendEmail: to
                });
            },
            setChargeDeliveryCost: function(to) {
                set({
                    chargeDeliveryCost: to
                });
            },
            cleanValues: function() {
                set({
                    sendEmail: true,
                    chargeDeliveryCost: true
                });
            }
        }
    };
});
var useAssistantPaymentOptions = function() {
    return useAssistantPaymentOptionsStore(function(state) {
        return {
            sendEmail: state.sendEmail,
            chargeDeliveryCost: state.chargeDeliveryCost
        };
    });
};
var useAssistantPaymentActions = function() {
    return useAssistantPaymentOptionsStore(function(state) {
        return state.actions;
    });
};


/***/ }),

/***/ 57500:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useLocalPaymentOption; },
/* harmony export */   "e": function() { return /* binding */ useLocalPaymentOptionsActions; }
/* harmony export */ });
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64529);

var useLocalPaymentOptionsStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* .create */ .Ue)()(function(set) {
    return {
        paymentOption: null,
        mixPayments: {
            CASH: 0,
            CARD: 0
        },
        actions: {
            setPaymentOption: function(to) {
                return set({
                    paymentOption: to
                });
            },
            setMixPayments: function(param) {
                var CASH = param.CASH, CARD = param.CARD;
                set({
                    mixPayments: {
                        CASH: CASH,
                        CARD: CARD
                    }
                });
            },
            cleanValues: function() {
                set({
                    paymentOption: null,
                    mixPayments: {
                        CASH: 0,
                        CARD: 0
                    }
                });
            }
        }
    };
});
var useLocalPaymentOption = function() {
    return useLocalPaymentOptionsStore(function(state) {
        return {
            paymentOption: state.paymentOption,
            mixPayments: state.mixPayments
        };
    });
};
var useLocalPaymentOptionsActions = function() {
    return useLocalPaymentOptionsStore(function(state) {
        return state.actions;
    });
};


/***/ }),

/***/ 69355:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M6": function() { return /* binding */ usePaymentSelectors; },
/* harmony export */   "oF": function() { return /* binding */ useOrderAndPaymentInfo; },
/* harmony export */   "pu": function() { return /* binding */ usePaymentMethodActions; }
/* harmony export */ });
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64529);

var usePaymentMethodStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* .create */ .Ue)()(function(set) {
    return {
        mekiCreditsChecked: true,
        insuranceId: null,
        totalReimbursement: 0,
        totalDeductible: 0,
        orders: [],
        ordersTotal: 0,
        paymentMethods: [],
        actions: {
            setMekiCreditsChecked: function(to) {
                set({
                    mekiCreditsChecked: to
                });
            },
            setInsuranceId: function(to) {
                set({
                    insuranceId: to
                });
            },
            setInsuranceTotalInfo: function(info) {
                set({
                    totalReimbursement: info.totalReimbursement,
                    totalDeductible: info.totalDeductible
                });
            },
            setOrders: function(to) {
                set({
                    orders: to
                });
            },
            setOrdersTotal: function(to) {
                set({
                    ordersTotal: to
                });
            },
            setPaymentMethods: function(to) {
                set({
                    paymentMethods: to
                });
            },
            cleanValues: function() {
                set({
                    mekiCreditsChecked: false,
                    insuranceId: null,
                    totalReimbursement: 0,
                    totalDeductible: 0,
                    orders: [],
                    ordersTotal: 0,
                    paymentMethods: []
                });
            }
        }
    };
});
var usePaymentSelectors = function() {
    return usePaymentMethodStore(function(state) {
        return {
            mekiCreditsChecked: state.mekiCreditsChecked,
            insuranceId: state.insuranceId,
            totalReimbursement: state.totalReimbursement,
            totalDeductible: state.totalDeductible
        };
    });
};
var useOrderAndPaymentInfo = function() {
    return usePaymentMethodStore(function(state) {
        return {
            orders: state.orders,
            ordersTotal: state.ordersTotal,
            paymentMethods: state.paymentMethods
        };
    });
};
var usePaymentMethodActions = function() {
    return usePaymentMethodStore(function(state) {
        return state.actions;
    });
};


/***/ }),

/***/ 47440:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fh": function() { return /* binding */ SkeletonContainer; },
/* harmony export */   "KI": function() { return /* binding */ AllInsurancesContainer; },
/* harmony export */   "Ws": function() { return /* binding */ AddInsuranceButton; },
/* harmony export */   "X2": function() { return /* binding */ Row; },
/* harmony export */   "XU": function() { return /* binding */ InsuranceCardText; },
/* harmony export */   "Y_": function() { return /* binding */ InsuranceCardTitle; },
/* harmony export */   "p_": function() { return /* binding */ InsuranceContainer; },
/* harmony export */   "sY": function() { return /* binding */ DeleteIconContainer; }
/* harmony export */ });
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87843);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29630);


var AllInsurancesContainer = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div")({
    display: "flex",
    flexDirection: "column",
    width: "100%",
    padding: "10px",
    gap: "10px",
    alignItems: "center"
});
var InsuranceContainer = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div")({
    display: "flex",
    width: "100%",
    flexDirection: "column",
    backgroundColor: "white",
    borderRadius: "10px",
    border: "1px solid #EAEAEA",
    padding: "10px"
});
var InsuranceCardTitle = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    display: "flex",
    fontFamily: "Poppins",
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "21px",
    width: "100%"
});
var InsuranceCardText = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    display: "flex",
    fontFamily: "Poppins",
    fontWeight: 300,
    fontSize: "16px",
    lineHeight: "24px",
    color: "#757475"
});
var Row = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div")({
    display: "flex",
    flexDirection: "row",
    width: "100%",
    justifyContent: "space-between"
});
var DeleteIconContainer = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("button")({
    display: "flex",
    justifyContent: "flex-end",
    cursor: "pointer",
    background: "transparent",
    borderWidth: "0px"
});
var AddInsuranceButton = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("button")({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "10px",
    backgroundColor: "transparent",
    width: "fit-content",
    borderRadius: "20px",
    border: "none",
    color: "#0A7ABE",
    fontFamily: "Poppins",
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "24px",
    cursor: "pointer"
});
var SkeletonContainer = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div")({
    display: "flex",
    flexDirection: "column",
    gap: 12,
    width: "100%",
    padding: "10px",
    border: "1px solid #EAEAEA",
    borderRadius: "10px"
});



/***/ }),

/***/ 43472:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ useOneClickRedirect; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(66383);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(50930);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(45680);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(66252);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(50319);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(51761);
/* harmony import */ var _queries_payment__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(66860);
/* harmony import */ var _queries_payment__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(50018);
/* harmony import */ var _utils_redirect__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(33756);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _hooks_useAuth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21566);
/* harmony import */ var _hooks_useOrderState__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(778);
/* harmony import */ var _hooks_toast_hook__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11263);
/* harmony import */ var _hooks_useSegment__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59945);
/*
 * File: useOneClickRedirect.ts
 * Project: meki
 * File Created: Monday, 11th January 2021 2:59:54 pm
 * Author: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Last Modified: Friday, 11th November 2022 12:46:04 pm
 * Modified By: Blanca Munizaga (blanca@inventures.cl)
 * -----
 * Copyright 2019 - 2021 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ 














/* Este hook se encarga de manejar todas las redirecciones de oneClick 
   y las interacciones con nuestro back-end para confirmar la inscripción de una tarjeta. */ function useOneClickRedirect() {
    var urlToRedirect = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "/pago/metodos", showError = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function() {}, handleIsRegistryError = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function() {};
    // Hooks init
    var apolloClient = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_6__/* .useApolloClient */ .x)();
    var ref = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)(), query = ref.query, replace = ref.replace;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var toasts = (0,_hooks_toast_hook__WEBPACK_IMPORTED_MODULE_4__/* .useToast */ .p)();
    var ref1 = (0,_hooks_useSegment__WEBPACK_IMPORTED_MODULE_5__/* .useSegment */ .K)(), track = ref1.track, flush = ref1.flush;
    // App state
    var ref2 = (0,_hooks_useOrderState__WEBPACK_IMPORTED_MODULE_3__/* .useOrderState */ .h)(), orderUuid = ref2.orderUuid, order = ref2.order;
    var ref3 = (0,_hooks_useAuth__WEBPACK_IMPORTED_MODULE_2__/* .useAuth */ .a)(), user = ref3.appUser;
    // Local State
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), loading = ref4[0], setLoading = ref4[1];
    // Other vars
    var finishedInscriptionRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    var ref5 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_apollo_client__WEBPACK_IMPORTED_MODULE_8__/* .useMutation */ .D)((0,_queries_payment__WEBPACK_IMPORTED_MODULE_9__/* .finishOneClickInscription */ .R)("finishOneClickPago"), {
        update: function update(cache, param) {
            var _$finishOneClickInscription = param.data.finishOneClickInscription;
            cache.modify({
                id: cache.identify((0,_apollo_client__WEBPACK_IMPORTED_MODULE_10__/* .makeReference */ .kQ)("ROOT_QUERY")),
                fields: {
                    paymentMethods: function paymentMethods(currentPaymentMethods) {
                        return [
                            _$finishOneClickInscription
                        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(currentPaymentMethods));
                    }
                }
            });
            if (order) cache.modify({
                id: cache.identify({
                    __ref: "Order:" + String(order.id)
                }),
                fields: {
                    paymentMethod: function paymentMethod() {
                        return _$finishOneClickInscription;
                    }
                }
            });
        }
    }), 1), finishOneClickMutation = ref5[0];
    // Effects
    /**
   * Handle one click return
   */ (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!query.TBK_TOKEN || !user || finishedInscriptionRef.current) return;
        finishedInscriptionRef.current = true;
        setLoading(true);
        finishOneClickMutation({
            variables: {
                params: {
                    token: query.TBK_TOKEN,
                    orderUuid: orderUuid
                }
            }
        }).then(function(response) {
            void track("add payment succeed", {
                payment_method_type: response.data.finishOneClickInscription.type,
                userId: user === null || user === void 0 ? void 0 : user.id
            });
        }).catch(function() {
            handleIsRegistryError();
            if (showError) return showError();
            toasts.showToast({
                message: "Ocurrio un error en la inscripci\xf3n del medio de pago",
                type: "error"
            });
        }).finally(function() {
            void router.replace({
                query: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, router.query), {
                    TBK_TOKEN: null
                })
            });
            setLoading(false);
        });
    }, [
        router,
        query.TBK_TOKEN,
        replace,
        finishOneClickMutation,
        orderUuid,
        user,
        toasts,
        showError,
        handleIsRegistryError,
        track, 
    ]);
    // Logic
    var getOneClickRedirectCallback = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(function() {
        var ref, _data, _getRedirectUrlOneClick, url, token, method;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_15__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        apolloClient.query({
                            query: (0,_queries_payment__WEBPACK_IMPORTED_MODULE_16__/* .getOneClickRedirect */ .j)("paymentSelectOneClick"),
                            variables: {
                                params: {
                                    urlReturn: window.location.origin + "/api/oneClick?redirectPath=".concat(urlToRedirect)
                                }
                            },
                            fetchPolicy: "network-only"
                        })
                    ];
                case 1:
                    ref = _state.sent(), _data = ref.data, _getRedirectUrlOneClick = _data.getRedirectUrlOneClick, url = _getRedirectUrlOneClick.url, token = _getRedirectUrlOneClick.token, method = _getRedirectUrlOneClick.method;
                    return [
                        2,
                        {
                            url: url,
                            token: token,
                            method: method
                        }
                    ];
            }
        });
    }), [
        apolloClient,
        urlToRedirect
    ]);
    var redirectCallback = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(function() {
        var ref, url, method, token;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_15__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    void track("add payment start", {
                        payment_method_type: "ONE_CLICK",
                        userId: user === null || user === void 0 ? void 0 : user.id
                    });
                    flush();
                    return [
                        4,
                        getOneClickRedirectCallback()
                    ];
                case 1:
                    ref = _state.sent(), url = ref.url, method = ref.method, token = ref.token;
                    (0,_utils_redirect__WEBPACK_IMPORTED_MODULE_17__/* .redirect */ .u)({
                        url: url,
                        method: method,
                        params: {
                            TBK_TOKEN: token
                        }
                    });
                    return [
                        2
                    ];
            }
        });
    }), [
        getOneClickRedirectCallback,
        track,
        flush
    ]);
    return [
        redirectCallback,
        {
            loading: loading
        }
    ];
}


/***/ }),

/***/ 33756:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ redirect; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66383);
/*
 * File: redirect.ts
 * Project: meki
 * File Created: Monday, 21st December 2020 3:30:15 pm
 * Author: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Last Modified: Friday, 12th February 2021 1:51:27 am
 * Modified By: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Copyright 2019 - 2020 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ 
function redirect(param) {
    var url = param.url, method = param.method, params = param.params;
    var form = document.createElement("form");
    form.style.display = "none";
    form.method = method;
    form.action = url;
    Object.entries(params).forEach(function(param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(param, 2), key = _param[0], value = _param[1];
        var input = document.createElement("input");
        input.name = key;
        input.value = value;
        form.appendChild(input);
    });
    document.body.appendChild(form);
    form.submit();
}


/***/ })

}]);